<div class="card">
    <div class="card-body">
        <div class="data-title">
            <div class="name">
                {{model.Name}} {{model.Surname}}
            </div>
            <div class="icon__user">
                <img src="../../../../assets/images/icons/user-icon-xl.svg" alt="Datos Receptor" class="img-fluid">
            </div>
        </div>
        <div class="data">
            <div class="w-100 pt-2 d-flex justify-content-between">
                <div>DNI:</div>
                <div>{{model.Dni}}</div>
            </div>
            <div class="w-100 pt-2 d-flex justify-content-between">
                <div>Fecha de nacimiento:</div>
                <div>{{model.Birthdate | date:'dd/MM/yyyy'}}</div>
            </div>
        </div>
        <div class="data mt-3">
            <div class="address">{{model.Address}}, {{model.Location}}, {{model.Cp}}, {{model.Province}}</div>
        </div>
        <div class="data mt-3">
          <div class="w-100 pt-2 d-flex justify-content-between">
            <div>Email personal:</div>
            <div>{{model.EmailPersonal}}</div>
          </div>
          <div class="w-100 pt-2 d-flex justify-content-between">
            <div>Teléfono personal:</div>
            <div>{{model.PhonePersonal}}</div>
          </div>
        </div>
    </div>
</div>

<!--<div class="card">
  <div class="card-body">
    <h5 class="card-title">{{model.Name}} {{model.Surname}}</h5>
    <p class="card-text">DNI: {{model.Dni}}</p>
    <p class="card-text">Fecha de nacimiento: {{model.Birthdate | date:'dd/MM/yyyy'}}</p>
    <p class="card-text">{{model.Address}}, {{model.Location}}, {{model.Cp}}, {{model.Province}}</p>
  </div>
</div>


<div class="card">
  <div class="card-body">
      <div class="data-title">
          <div class="name">
              Nombre del receptor
          </div>
          <div class="icon__user">
              <img src="../../../../assets/images/icons/user-icon-xl.svg" alt="Datos Receptor" class="img-fluid">
          </div>
      </div>
      <div class="data">
          <div class="w-100 pt-2 d-flex justify-content-between">
              <div>DNI:</div>
              <div>00.000.000A</div>
          </div>
          <div class="w-100 pt-2 d-flex justify-content-between">
              <div>Fecha de nacimiento:</div>
              <div>dd/mm/aaaa</div>
          </div>
      </div>
      <div class="data mt-3">

          <div class="address">Dirección completa</div>
          <div class="email">renault@renaultretailgroup.es</div>
          <div class="phone">555 555 555</div>

      </div>
  </div>
</div>-->
